// extracted by mini-css-extract-plugin
module.exports = {"modal":"NewItem_modal__38aqd","header":"NewItem_header__qqfLW","title":"NewItem_title__1Fj0A","buttons":"NewItem_buttons__AJ3uL","exitButton":"NewItem_exitButton__ZNU3X"};